import React from 'react'
import styled from 'styled-components'
import { Heading, Text } from '@pancakeswap/uikit'
import { useProfile } from 'state/profile/hooks'
import { useTranslation } from 'contexts/Localization'
import NoProfileCard from './NoProfileCard'

const HeadingStyle = styled(Heading)`
  font-size: 24px;
  line-height: 48px;
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 48px;
    line-height: 72px;
  }
`
const SubInfoStyle = styled.div`
  font-size: 14px;
  line-height: 18px;
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 18px;
    line-height: 28px;
  }
`
const HeaderWrapper = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  ${({ theme }) => theme.mediaQueries.lg} {
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`

const CommunityHeader = () => {
  const { t } = useTranslation()
  const { isInitialized, profile } = useProfile()
  const showProfileCallout = isInitialized && !profile

  return (
    <>
      {showProfileCallout && <NoProfileCard />}
      <HeaderWrapper>
        <HeadingStyle color="secondary">
          {t('Community')}
        </HeadingStyle>
        <SubInfoStyle>
          {t('Join Deblox community to get our latest info and connect with other Debloxers')}
        </SubInfoStyle>
      </HeaderWrapper>
    </>
  )
}

export default CommunityHeader
